import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { firebase_auth } from '../firebase/firebaseConfig';
import './AdminMenuBar.css';

const AdminMenuBar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(firebase_auth);
      sessionStorage.removeItem('adminAuthenticated');
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <div className={`menu-overlay ${isMenuOpen ? 'visible' : ''}`} onClick={closeMenu} />
      
      {/* Header fijo para móvil */}
      <div className="mobile-header">
        <div className="admin-logo">
          <Link to="/" onClick={closeMenu}>
            Admin Panel
          </Link>
        </div>
        <div className="burger-menu-button" onClick={toggleMenu}>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`burger-line ${isMenuOpen ? 'open' : ''}`}></div>
        </div>
      </div>

      <nav className={`admin-menu-bar ${isMenuOpen ? 'menu-open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="admin-menu-container">
          <div className="admin-logo">
            <Link to="/" onClick={closeMenu}>
              Admin Panel
            </Link>
            <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
              {isCollapsed ? (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>

          <div className="admin-nav-links">
            <Link
              to="/"
              className={`admin-nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span>Inicio</span>
            </Link>

            <Link
              to="/estadisticas"
              className={`admin-nav-link ${location.pathname === '/estadisticas' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="20" x2="18" y2="10" />
                <line x1="12" y1="20" x2="12" y2="4" />
                <line x1="6" y1="20" x2="6" y2="14" />
              </svg>
              <span>Estadísticas</span>
            </Link>

            <Link
              to="/exportar"
              className={`admin-nav-link ${location.pathname === '/exportar' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <span>Exportar Reservas</span>
            </Link>

            <Link
              to="/calendario"
              className={`admin-nav-link ${location.pathname === '/calendario' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
              <span>Administrar Calendario</span>
            </Link>

            <Link
              to="/habitaciones"
              className={`admin-nav-link ${location.pathname === '/habitaciones' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 4v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
                <path d="M2 8h20" />
                <path d="M2 12h20" />
                <path d="M2 16h20" />
                <path d="M4 4v4" />
                <path d="M20 4v4" />
              </svg>
              <span>Gestionar Habitaciones</span>
            </Link>

            <Link
              to="/finanzas"
              className={`admin-nav-link ${location.pathname === '/finanzas' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
              </svg>
              <span>Finanzas</span>
            </Link>

            <Link
              to="/precios"
              className={`admin-nav-link ${location.pathname === '/precios' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="5" width="22" height="14" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
                <path d="M12 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
              </svg>
              <span>Precios por Temporada</span>
            </Link>

            <Link
              to="/recomendaciones"
              className={`admin-nav-link ${location.pathname === '/recomendaciones' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                <line x1="4" y1="22" x2="4" y2="15" />
              </svg>
              <span>Recomendaciones</span>
            </Link>

            <Link
              to="/galeria"
              className={`admin-nav-link ${location.pathname === '/galeria' ? 'active' : ''}`}
              onClick={closeMenu}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span>Galería de Imágenes</span>
            </Link>

            <button className="admin-logout-btn" onClick={handleLogout}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              <span>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default AdminMenuBar; 